function NotificationsListController(
  $scope,
  $log,
  $translate,
  $stateParams,
  LoggedInUser,
  notificationService,
  navigationService,
  layoutService
) {
  let recipientType = 'group';
  let recipientId = $stateParams.groupId || null;

  $scope.user = LoggedInUser;
  $scope.group = !!$stateParams.groupId;

  if (!$scope.group) {
    recipientType = 'user';
    recipientId = $scope.user.username;
    navigationService.navigateProfile('profile.notifications');
  } else {
    navigationService.navigateGroup('groups.group.notifications');
  }

  $scope.alerts = [];
  function resetAlerts() {
    $scope.alerts = [];
  }

  $scope.loadMore = {
    eligible: false,
    page: 0,
    resultsPerPage: 20
  };

  notificationService.initialized.then(() => {
    $scope.getNotifications();
  });

  $scope.getNotifications = () => {
    resetAlerts();
    notificationService.getAll(recipientType, recipientId, $scope.loadMore.page).then((data) => {
      $scope.loadMore.requestRunning = false;

      if ($scope.loadMore.page > 0) {
        const updatedList = data.reduce((acc, item) => {
          const index = acc.findIndex(notif => notif.id === item.id);
          if (index < 0) {
            acc.push(item);
          }
          return acc;
        }, $scope.notifications);

        $scope.notifications = updatedList;
      } else if (data.length) {
        $scope.notifications = data;

        const mobileToast = data.length > 1 ? `${data.length} ${$translate.instant('NOTIFICATIONS_FOUND')}` : $translate.instant('ONE_NOTIFICATION_FOUND');
        layoutService.mobileToast('info', mobileToast);
      } else {
        $scope.notifications = [];
      }

      $scope.loadMore.eligible = data.length >= $scope.loadMore.resultsPerPage;

      if (recipientType === 'user' && $scope.loadMore.page === 0) {
        $scope.getEasyNotifications(data, $scope.loadMore.eligible);
      }
    }, (response) => {
      $log.error('NotificationsListController getNotifications() error:', response.error || response);
      $scope.notifications = [];
      $scope.alerts.push({
        type: 'danger',
        msg: $translate.instant('ERROR_LOADING_NOTIFICATIONS')
      });
    });
  };

  $scope.loadMoreNotifications = () => {
    if (!$scope.loadMore.eligible) {
      return;
    }
    $scope.loadMore.page += 1;
    $scope.loadMore.requestRunning = true;
    $scope.getNotifications();
  };

  $scope.getEasyNotifications = (data, loadMoreEligible) => {
    if (loadMoreEligible) {
      notificationService.getEasyNotifications(recipientId).then((easyNotifications) => {
        $scope.easyNotifications = easyNotifications;
      }, () => {
        $scope.easyNotificationsError = true;
        $scope.easyNotifications = [];
      });
    } else {
      $scope.easyNotifications = data.filter(notification => notification.easyNotificationType);
    }
  };
}

const controllerArray = [
  '$scope',
  '$log',
  '$translate',
  '$stateParams',
  'LoggedInUser',
  'notificationService',
  'navigationService',
  'layoutService',
  NotificationsListController
];

module.exports = (ngModule) => {
  ngModule.controller('NotificationsListController', controllerArray);
};
